export default defineI18nConfig(() => {
  return {
    numberFormats: {
      en: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      de: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      fr: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      nl: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      ch: {
        currency: {
          style: 'currency',
          currency: 'CHF',
        },
      },
    },
    datetimeFormats: {
      // https://kazupon.github.io/vue-i18n/guide/datetime.html
      'en-GB': {
        short: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      de: {
        short: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      fr: {
        short: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      nl: {
        short: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
    },
    fallbackLocale: 'en',
  };
});
